import { useAppSelector } from '../../../hooks/redux';
import { postExposure } from '../../../laboratory';
import { selectPortalId } from '../../../selectors/portal.selectors';
import { GROW_GUIDE_USER_GUIDE_EXPERIMENT_KEY } from '../constants/experiments';
import { useGrowGuide } from '../hooks/useGrowGuide';
import { useGrowGuideUserGuideExperiment } from '../hooks/useGrowGuideUserGuideExperiment';
import { getHasBeenExposedToExperiment, setHasBeenExposedToExperiment } from '../utils/experimentUtils';
import { GrowGuideButton } from './GrowGuideButton';
import { UserGuideButton } from './UserGuideButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const GrowGuideContainer = () => {
  const {
    shouldRenderGrowGuide
  } = useGrowGuide();
  const {
    isEligibleForExperiment,
    isEligibilityLoading,
    isVariant
  } = useGrowGuideUserGuideExperiment();
  const portalId = useAppSelector(selectPortalId);
  if (shouldRenderGrowGuide) {
    return /*#__PURE__*/_jsx(GrowGuideButton, {});
  }
  const isEligibleForUserGuideExperiment = !isEligibilityLoading && isEligibleForExperiment;
  const shouldLogExposure = isEligibleForUserGuideExperiment && !getHasBeenExposedToExperiment(GROW_GUIDE_USER_GUIDE_EXPERIMENT_KEY, portalId);
  if (isEligibleForUserGuideExperiment) {
    if (shouldLogExposure) {
      void postExposure(['coac-0003'], `${portalId}`, {
        portalId
      });
      setHasBeenExposedToExperiment(GROW_GUIDE_USER_GUIDE_EXPERIMENT_KEY, portalId);
    }
    if (isVariant) {
      return /*#__PURE__*/_jsx(UserGuideButton, {});
    }
  }
  return null;
};